// Tom Select

'use strict';

import * as helper from '../../../../src/js/helpers';

import TomSelect from "tom-select";
import {injcectVirtualStackFrame} from "@babel/core/lib/errors/rewrite-stack-trace";

window.TomSelect = TomSelect;

icing.watch('[data-select]', select => {

    const defaultOptions = {
        onChange: function () {
            this.wrapper.classList.toggle('is-invalid', !this.isValid);
        },
        onDropdownOpen: function () {
            this.control_input.classList.remove('dropdown-input');
            this.control_input.classList.add('form-control');
            this.control_input.placeholder = "Search";
        },
        plugins: ['dropdown_input'],
        allowEmptyOption: !select.hasAttribute('required')
            && !select.hasAttribute('multiple')
            && (select.querySelector('option[value=""]')?.textContent.trim()?.length > 1),
    };

    const userOptions    = select.dataset.select ? JSON.parse(select.dataset.select) : {};
    const optionTemplate = select.dataset.optionTemplate;
    const itemTemplate   = select.dataset.itemTemplate;

    const templateOptions = {};
    if (optionTemplate || itemTemplate) {
        templateOptions.render = {};
        if (optionTemplate) {
            templateOptions.render.option = (data, escape) => {
                return optionTemplate.replace(/\[\[.+?\]\]/g, (match) => {
                    const key = helper.getSubstringBetween(match, '[[', ']]');
                    return escape(data[key] !== undefined ? data[key] : '');
                });
            };
        }
        if (itemTemplate) {
            templateOptions.render.item = (data, escape) => {
                return itemTemplate.replace(/\[\[.+?\]\]/g, (match) => {
                    const key = helper.getSubstringBetween(match, '[[', ']]');
                    return escape(data[key] !== undefined ? data[key] : '');
                });
            };
        }
    }

    let options = {
        ...defaultOptions,
        ...userOptions,
        ...templateOptions
    };

    if (typeof options.load === 'string') {
        let url = options.load;
        if (url.includes('?')) {
            url += '&q=';
        } else {
            url += '?q=';
        }

        options.load = function (query, callback) {
            fetch(url + encodeURIComponent(query))
                .then(response => response.json())
                .then(items => items
                    .map(item => Object.keys(item)
                        .reduce((acc, key) => {
                            if (key.startsWith('data-')) {
                                const newKey = key.slice(5);
                                if (!acc.hasOwnProperty(newKey)) {
                                    acc[newKey] = item[key];
                                }
                            } else {
                                acc[key] = item[key];
                            }
                            return acc;
                        }, {})
                    )
                    .map(item => ({
                        ...item,
                        value: item.value ?? item.id ?? null,
                        text: item.text ?? item.name ?? item.title ?? item.value ?? item.id ?? null
                    }))
                    .filter(item => !!item.value)
                )
                .then(json => callback(json))
                .catch(() => callback());
        };
    }

    if (typeof options.create === 'string') {
        let url = options.create;
        if (url.includes('?')) {
            url += '&q=';
        } else {
            url += '?q=';
        }
        options.create = function (input) {
            const here           = window.location.href;
            window.location.href = url + encodeURIComponent(input) + '&redirect=' + here;
        };
    }

    if (select.dataset.escape === 'false') {
        options.render = {
            option: (data, escape) => {
                return '<div>' + (data.text) + '</div>';
            },
            item: (data, escape) => {
                return '<div>' + (data.text) + '</div>';
            }
        };
    }

    let selectEl          = new TomSelect(select, options);
    selectEl.getValueData = function () {
        const value = selectEl.getValue();
        if (!value) {
            return {};
        }
        const option = selectEl.options[value];
        if (!option) {
            return {};
        }
        if (typeof option.data === "object") {
            return option.data;
        }
        return {};
    };

    if (select.getAttribute('style')) {
        selectEl.wrapper.setAttribute('style', select.getAttribute('style'));
    }

    const form = select.closest('form.needs-validation');

    if (form) {
        form.addEventListener('submit', (e) => {
            selectEl.wrapper.classList.toggle('is-invalid', !selectEl.isValid);

            if (!form.checkValidity()) {
                e.preventDefault()
                e.stopPropagation()
            }

            form.classList.add('was-validated');
        }, false);
    }
});

